import type { ICustomControlSupervisionReadProps } from '../../interfaces/';
import { translateKey } from '../../../../../translate';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function TiecgV1SupervisionBiometricsSummary(props: ICustomControlSupervisionReadProps) {
    return (
        <HorizontalFormGroupRead>
            <FormLabel>Kwaliteit meting</FormLabel>
            <InputContainer>
                <FormParagraph>
                    {props.supervision.assessmentBiometrics
                        ? translateKey(`supervisorsAssessmentBiometricsEnum.${props.supervision.assessmentBiometrics}`)
                        : '-'}
                </FormParagraph>
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}
